export const HOME_ROUTE = '/';
export const DATA_ROUTE = '/mis-datos';
export const PASSWORD_ROUTE = '/mis-datos/contraseña';
export const ADDRESS_ROUTE = '/mis-datos/direcciones';
export const PURCHASE_ROUTE = '/mis-compras';
export const TICKETS_ROUTE = '/mis-solicitudes';
export const GIFTCARD_BALANCE_ROUTE = '/saldo-giftcard';
export const MY_CLUBS_ROUTE = '/mis-clubes';
export const POINTS_ROUTE = '/mis-puntos';
export const BENEFITS_ROUTE = '/mis-puntos/beneficios';
export const EXCHANGE_ROUTE = '/mis-puntos/canjes';
export const REQUEST_NOT_PRODUCT_TICKET = '/mis-solicitudes/realizar-solicitud';
export const CONTACT_US_ROUTE = '/contactanos';
export const MENU_ROUTE = '/menu';
export const EXCHANGE_DETAIL_ROUTE = '/mis-puntos/canjes/instrucciones';
export const PRODUCT_DETAIL_MOBILE_ROUTE = '/mis-compras/detalle';
export const PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE =
  '/mis-compras/detalle/tracking';
export const TICKET_DETAIL_MOBILE_ROUTE = '/mis-solicitudes/detalle';
export const REPORT_ISSUES = '/mis-compras/reportar-inconveniente';
export const AUTHORIZE_THIRD =
  '/mis-compras/reportar-inconveniente/autorizar-tercero';
export const CHANGE_DISPATCH_ADDRESS =
  '/mis-compras/reportar-inconveniente/cambiar-direccion-despacho';
export const CHANGE_DISPATCH_DATE =
  '/mis-compras/reportar-inconveniente/cambiar-fecha-despacho';
export const SILVER_GOLD_PAYMENT =
  '/mis-compras/reportar-inconveniente/cobro-silver-gold';
export const BAD_STATE = '/mis-compras/reportar-inconveniente/mal-estado';
export const ARRIVED_INCOMPLETE =
  '/mis-compras/reportar-inconveniente/llego-incompleto';
export const NOT_WORKING = '/mis-compras/reportar-inconveniente/no-funciona';
export const PRODUCT_CHANGE =
  '/mis-compras/reportar-inconveniente/cambio-producto';
export const ANOTHER_PRODUCT =
  '/mis-compras/reportar-inconveniente/otro-producto';
export const ASSEMBLE_PRODUCT =
  '/mis-compras/reportar-inconveniente/armar-producto';
export const ALARM_IN_PRODUCT =
  '/mis-compras/reportar-inconveniente/alarma-en-producto';
export const CANCEL_PURCHASE =
  '/mis-compras/reportar-inconveniente/cancelacion-compra';
export const CANCELLATION_PURCHASE_STATUS =
  '/mis-compras/reportar-inconveniente/status-cancelacion-compra';
export const NOT_RECEIVED =
  '/mis-compras/reportar-inconveniente/producto-no-recibido';
export const REQUEST_BLOCK_CARD =
  '/mis-solicitudes/realizar-solicitud/bloquear-tarjeta';
export const REQUEST_CHANGE_RIPLEYCARD =
  '/mis-solicitudes/realizar-solicitud/bloquear-tarjeta-ripley';
export const REQUEST_PAY_ACCOUNT =
  '/mis-solicitudes/realizar-solicitud/pagar-tarjeta';
export const REQUEST_RPGO_INFORMATION =
  '/mis-solicitudes/realizar-solicitud/rpgo-info';
export const REQUEST_INSURANCES_INFORMATION =
  '/mis-solicitudes/realizar-solicitud/seguros-ripley';
export const REQUEST_BILL_IMAGE = '/mis-solicitudes/realizar-solicitud/boleta';
export const REPORT_PAGE_ERROR =
  '/mis-solicitudes/realizar-solicitud/error-en-pagina';
export const REPORT_PURCHASE_ERROR =
  '/mis-solicitudes/realizar-solicitud/error-al-comprar';
export const REQUEST_EXTEND_GIFT_CARD =
  '/mis-solicitudes/realizar-solicitud/extender-giftcard';
export const REQUEST_EXTEND_GIFT_CARD_COMPANY =
  '/mis-solicitudes/realizar-solicitud/extender-giftcard-empresa';
export const REPORT_GIFTCARD_PROBLEM =
  '/mis-solicitudes/realizar-solicitud/problema-giftcard';
export const GENERAL_CLUBS_PROBLEMS =
  '/mis-solicitudes/realizar-solicitud/clubes-general';
export const PAY_CARD = '/pagar-tarjeta';
